import axios from "axios";

const API_URL = process.env.REACT_APP_SHAREPOINT_API_URL;

const getCommonDocuments = async () => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }
  
  let response = await axios.post(API_URL + "getCommonDocuments", {email: JSON.parse(localStorage.getItem("user")).email}, config)
  console.log(response.data)
  return response.data
};

const getUserDocuments = async () => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  let response = await axios.post(API_URL + "getUserDocuments", {email: JSON.parse(localStorage.getItem("user")).email}, config)
  return response
};

const getDownloadFile = async (reqfile) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) throw new Error("Kein Benutzer gefunden");

    const config = {
      responseType: "blob",
      headers: {
        "x-access-token": user.accessToken,
      },
    };

    console.log(reqfile)
    const data = {
      email: user.email,
      file: {
        name: reqfile.name,  // Datei-Name
        itemId: reqfile.listitemID, // ID des Listenelements
      },
    };

    let response = await axios.post(API_URL + "getDownloadFile", data, config);
    return response.data;
  } catch (error) {
    console.error("Fehler beim Abrufen der Datei:", error);
    return null;
  }
};

const getCustomerManager = async(email) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

    let response = await axios.post(API_URL + "getCustomerManager", {email: email}, config)
    return response.data
}

const getProjectList = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  let response = await axios.post(
    API_URL + "getProjectList", 
    {
      email: JSON.parse(localStorage.getItem("user")).email
    }, 
    config
  )
  return response
}

const uploadFiles = async (filesWithCategories, projectId) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken,
    },
  };

  const formData = new FormData();
  formData.append("email", JSON.parse(localStorage.getItem("user")).email);
  formData.append("projectId", projectId);

  // Hilfsfunktion zur Generierung eines 6-stelligen zufälligen Strings
  const generateRandomString = () => Math.random().toString(36).substring(2, 8);

  if (!Array.isArray(filesWithCategories) || filesWithCategories.length === 0) {
    console.error("Fehler: `filesWithCategories` ist kein Array oder leer.");
    return;
  }

  filesWithCategories.forEach((fileWithCategory, index) => {
    const { files, category } = fileWithCategory;

    // Überprüfen, ob `files` ein FileList- oder Array-Objekt ist
    if (!files || !(files instanceof FileList || Array.isArray(files))) {
      console.error("Fehler: `files` für Kategorie " + category + " ist kein gültiges FileList- oder Array-Objekt.");
      return;
    }

    Array.from(files).forEach((file, fileIndex) => {
      const randomString = generateRandomString();

      // Erstelle einen neuen Dateinamen basierend auf Kategorie und Zufallsstring
      const fileExtension = file.name.split('.').pop();
      const newFileName = `${category.replace(/\s+/g, '_')}_${randomString}.${fileExtension}`;

      // Erstelle einen neuen Blob mit dem neuen Dateinamen
      const renamedFile = new File([file], newFileName, { type: file.type });

      // Füge die Datei und die zugehörige Kategorie zu FormData hinzu
      formData.append(`file${index}_${fileIndex}`, renamedFile);
      formData.append(`category${index}_${fileIndex}`, category);
    });
  });

  try {
    let response = await axios.post(API_URL + "uploadFiles", formData, config);
    return response.data;
  } catch (error) {
    console.error("Fehler beim Upload:", error);
  }
};




const SharePointService = {
    getCommonDocuments,
    getUserDocuments,
    getDownloadFile,
    getCustomerManager,
    getProjectList,
    uploadFiles
}

export default SharePointService;